module.exports = __webpack_public_path__ + "img/reasonableFees2x.c5bb5c18.png";